import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { viewCountryList } from "../../Redux/Actions/settingsActions";
import { columnsCountry } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListCountry = () => {
  // const STALE_TIME = process.env.REACT_APP_STALE_TIME;
  const [searchQuery, setQuerySearch] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { loading, countryList } = useSelector((state) => state.country);

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const fetchCountryDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const countryData = {
      page,
      limit: pageSize,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(viewCountryList(countryData, showLoader));
      if (!showLoader) {
        toast.success("Country list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh country list");
      }
    }
  }, [dispatch, debouncedSearch, dateRange]);

  // const isStale = !lastFetched || Date.now() - lastFetched > STALE_TIME;

  useEffect(() => {
    fetchCountryDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchCountryDetails]);

  useEffect(() => {
    if (countryList?.total) {
      setPagination((prevData) => ({ ...prevData, total: countryList.total }));
    }
  }, [countryList]);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearch(searchQuery);
      }, 500);
  
      return () => clearTimeout(handler);
    }, [searchQuery]);
  

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchCountryDetails(pagination.current, pagination.pageSize);
  };

  // const filterHandler = () => {
  //   setPagination((prevData) => ({ ...prevData, current: 1 }));
  //   fetchCountryDetails(1, pagination.pageSize);
  // };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const column = useMemo(() => columnsCountry(canEdit), [canEdit]);
  const dataSource = useMemo(
    () => (Array.isArray(countryList?.data) ? countryList.data : []),
    [countryList]
  );

  return (
    <>
      <TableComponent
        h3heading="Country List"
        buttonhead2={canAdd ? "Add Country" : null}
        // filterFunction={filterHandler}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        navigateTo2={canAdd ? "/country/add" : null}
        setState={setQuerySearch}
        columns={column}
        dataSource={dataSource}
        onChange={handleTableChange}
        loading={loading}
        pagination={pagination}
      ></TableComponent >

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListCountry;
